/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  DOCUMENT_STATUS_VIEW__HIDE,
  DOCUMENT_STATUS_VIEW__SHOW,
  FETCHING_DOCUMENTS,
  RECEIVE_DOCUMENTS,
  ERROR_DOCUMENTS,
  DELETE_PARTICIPANT_DOCUMENT_ERROR,
  CLEAR_DOCUMENTS
} from '../actions/actionTypes';

const documentsState = {
  studyGid: null,
  participantId: null,
  isFetching: false,
  items: null,
  error: null,
  renderChangeStatusPage: false,
  deleteDocumentError: null,
  consentings: null
};

const documentsReducer = (state = documentsState, action) => {
  switch (action.type) {
    case FETCHING_DOCUMENTS:
      return Object.assign({}, state, { isFetching: true });
    case RECEIVE_DOCUMENTS:
      return Object.assign({}, state, { isFetching: false, items: action.payload, error: null });
    case CLEAR_DOCUMENTS:
      return Object.assign({}, state, { isFetching: false, items: null, error: null });
    case ERROR_DOCUMENTS:
      return Object.assign({}, state, { isFetching: false, error: action.payload });
    case DOCUMENT_STATUS_VIEW__SHOW:
      return Object.assign({}, state, { renderChangeStatusPage: true });
    case DOCUMENT_STATUS_VIEW__HIDE:
      return Object.assign({}, state, { renderChangeStatusPage: false });
    case DELETE_PARTICIPANT_DOCUMENT_ERROR:
      return Object.assign({}, state, { deleteDocumentError: action.payload });
    default:
      return state;
  }
};

export default documentsReducer;
